import dayjs from "dayjs"
import { StrategyValue, strategyValueObject } from "src/features/calculator/utils/calculator"
import { NumberOfPayments } from "src/features/calculator/utils/calculator"

// 20231030受客再開加盟店
export function is20231030RestartedJukyakuStores(storeName: string): boolean {
  return [
    "株式会社クイックエステート",
    "アド.プランニング株式会社",
    "Work Full House",
    "へやなび横濱関内（株）GHエステート",
    "お部屋探しならリルーム",
  ].some((name) => storeName.includes(name))
}

// 20230907受託再開加盟店
export function is20230907RestartedJukyakuStores(storeName: string): boolean {
  return [
    "アエラス",
    "株式会社ソレイユ",
    "株式会社グランデ",
    "株式会社リアリースエージェント",
    "合同会社K&M不動産",
    "株式会社リーテック",
    "有限会社リーウェイズ",
  ].some((name) => storeName.includes(name))
}

// 20210101受客0円キャンペーン継続加盟店
export function is20210101ZeroYenCampaignContinuingJukyakuStores(storeName: string) {
  return ["アエラス", "ソレイユ", "グランデ"].some((name) => storeName.includes(name))
}

interface AutoDetermineParams {
  adPrice: number
  storeName: string
  isRecipient: boolean
  // 分割回数
  nop: number
  applicatedAt: dayjs.Dayjs
}

export function autoDetermineFormula({
  adPrice,
  storeName,
  isRecipient,
  nop,
  applicatedAt,
}: AutoDetermineParams): StrategyValue {
  if (isRecipient) {
    if (dayjs.isDayjs(applicatedAt) && applicatedAt.isAfter("2023-11-30", "days")) {
      // MEMO(@nontangent): 12月1日以降、全加盟店で受客0％での再開
      return strategyValueObject.jukyakuTaxIncluded0Percent
    } else if (
      dayjs.isDayjs(applicatedAt) &&
      applicatedAt.isAfter("2023-10-29", "days") &&
      is20231030RestartedJukyakuStores(storeName)
    ) {
      return strategyValueObject.jukyakuTaxIncluded30Percent
    } else if (
      dayjs.isDayjs(applicatedAt) &&
      applicatedAt.isAfter("2023-09-06", "days") &&
      is20230907RestartedJukyakuStores(storeName)
    ) {
      return strategyValueObject.jukyakuTaxIncluded16_5Percent
    } else if (dayjs.isDayjs(applicatedAt) && applicatedAt.isAfter("2022-12-31", "days")) {
      if (is20210101ZeroYenCampaignContinuingJukyakuStores(storeName)) {
        return strategyValueObject.jukyakuTaxIncluded0Percent
      } else {
        if (nop === NumberOfPayments.Split6) {
          return strategyValueObject.jukyakuTaxIncluded30Percent
        } else {
          return strategyValueObject.jukyakuTaxIncluded0Percent
        }
      }
    } else {
      return strategyValueObject.jukyakuTaxIncluded0Percent
    }
  } else if (storeName.includes("イースマイル")) {
    return strategyValueObject.fullReimbursement
  } else if (storeName.includes("株式会社ハナインターナショナル")) {
    return strategyValueObject.hanaInternational
  } else if (storeName.includes("株式会社リアリースエージェント")) {
    return adPrice > 0 ? strategyValueObject.riaHouseWithAd : strategyValueObject.riaHouseWithoutAd
  } else if (storeName.includes("株式会社エスフィット")) {
    return strategyValueObject.sFit
  } else if (storeName.includes("株式会社en company")) {
    return strategyValueObject.eCompany
  } else if (storeName.includes("株式会社ハウスパートナー")) {
    return strategyValueObject.housePartner
  } else if (storeName.includes("グローバルエステート")) {
    return strategyValueObject.globalEstate
  } else if (storeName.includes("トーマスリビング")) {
    return strategyValueObject.thomasLiving
  } else if (storeName.includes("エリッツ")) {
    return strategyValueObject.elitz
  } else if (storeName.includes("ROOMPIA")) {
    return strategyValueObject.fullReimbursement
  } else if (storeName.includes("SAGASSO")) {
    return strategyValueObject.fullReimbursement
  } else if (storeName.includes("株式会社カインドトラスト")) {
    return strategyValueObject.fullReimbursement
  } else if (storeName.includes("株式会社アルファブレインジャパン")) {
    return strategyValueObject.alphaBrain
  } else if (storeName.includes("RE/MAX Revo") && adPrice === 0) {
    return strategyValueObject.reMaxRevoWithoutAd
  } else if (storeName.includes("anybody株式会社")) {
    if (adPrice > 0) {
      return strategyValueObject.anybodyWithAd
    } else {
      return strategyValueObject.anybodyWithoutAd
    }
  } else if (storeName.includes("吉田不動産")) {
    return strategyValueObject.fullReimbursement
  } else if (storeName.includes("ハウスコーポレーション")) {
    return strategyValueObject.houseCorporation
  } else if (storeName.includes("禅リアルエステート合同会社")) {
    return strategyValueObject.fullReimbursement
  } else {
    return strategyValueObject.basic
  }
}
